import { ref, shallowRef } from 'vue'

export type ScreenOverwritePayload = {
  title: string
  body: string
  confirmLabel: string
  cancelLabel: string
}

const dialogOpen = ref(false)
const dialogPayload = shallowRef<ScreenOverwritePayload | null>(null)
let pendingResolve: ((v: boolean) => void) | null = null

/**
 * 供 `ScreenMediaOverwriteDialog.vue` 绑定：弹层开关与文案。
 */
export function getScreenMediaOverwriteDialogState() {
  return { dialogOpen, dialogPayload }
}

export function resolveScreenMediaOverwriteFromDialog(confirmed: boolean): void {
  dialogOpen.value = false
  const r = pendingResolve
  pendingResolve = null
  dialogPayload.value = null
  r?.(confirmed)
}

/**
 * 打开互斥覆盖确认弹窗（由宿主挂载的 `<dialog>` 呈现）。
 */
export function requestScreenMediaOverwriteConfirm(payload: ScreenOverwritePayload): Promise<boolean> {
  return new Promise((resolve) => {
    dialogPayload.value = payload
    pendingResolve = resolve
    dialogOpen.value = true
  })
}
